export const REMOVE_TEMP_NOTIFICATION = "REMOVE TEMP NOTIFICATION";
export const ADD_TEMP_NOTIFICATION_TO_PENDING =
  "ADD TEMP NOTIFICATION TO PENDING";
export const DISPLAY_TEMP_NOTIFICATION = "DISPLAY TEMP NOTIFICATION";
export const DISPLAY_PENDING_TEMP_NOTIFICATION =
  "DISPLAY PENDING TEMP NOTIFICATION";
